import { useSelector } from 'react-redux';
import { IReduxState } from 'app/store';
import { LoginService } from 'login/services/login.service';

export function RelatedNamesActionsDropdown(props: any) {
  const { user } = useSelector((state: IReduxState) => state.login);

  const isDisabled = (): boolean => {
    if (LoginService.isViewer(user)) {
      return true;
    }
    return false;
  };

  const handleClick = () => {
    if (isDisabled()) {
      return;
    }
    const assetName = props.params.row.asset;
    if (props.onDeletePopup) {
      props.onDeletePopup([assetName], 'delete-related-names');
    }
  };

  return (
    <div className="RelatedNamesActionsDropdown">
      <img
        className={isDisabled() ? 'disabled' : ''}
        alt="delete asset"
        src="/assets/images/trash.svg"
        onClick={handleClick}
        style={{
          cursor: isDisabled() ? 'not-allowed' : 'pointer',
          opacity: isDisabled() ? 0.3 : 1,
          width: '16px',
          height: '16px'
        }}
      />
    </div>
  );
}
